import {Construtor} from './construtor';

export class PercentualTipo implements Construtor<PercentualTipo> {

  public descricaoTipoOcorrencia: string;
  public percentual: number;

  constructor(object?: any) {
    if (object !== undefined) {
      if (object instanceof (PercentualTipo)) {
        this.copyObject(object);
      } else {
        this.parseFromJson(object);
      }

      if (!this.modeloCompleto()) {
        return null;
      }
    }
  }

  parseFromJson(pencentualPontoFisico: any): void {
    this.descricaoTipoOcorrencia = pencentualPontoFisico.descricaoTipoOcorrencia;
    this.percentual = pencentualPontoFisico.percentual;
  }

  copyObject(pencentualPontoFisico: PercentualTipo): void {
    this.descricaoTipoOcorrencia = pencentualPontoFisico.descricaoTipoOcorrencia;
    this.percentual = pencentualPontoFisico.percentual;
  }

  modeloCompleto(): boolean {
    return this.descricaoTipoOcorrencia !== undefined && this.percentual !== undefined;
  }

  getNewInstance(object?: any): PercentualTipo {
    return new PercentualTipo(object);
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/percentual-tipo.ts